import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { FETCH_REQUEST, fetchSuccess, fetchError } from '../../actions/blueprints/publicList';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { getURLWithParams } from '../../../utils/url';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { filters } = action.payload;
    const url = getURLWithParams(`${config.API_URL}/models/public`, filters);
    
    const response = yield call(axios.get, url, {
      headers: getLocalUser()
    });
    
    yield put(fetchSuccess(response.data.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchError(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(FETCH_REQUEST, operation);
} 